module.exports = __webpack_public_path__ + "img/GAME_PIANO.a85e3466.png";